import './polyfills'

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/app/App';
//import { Provider } from 'react-redux'
//import { createStore } from 'redux'
import * as serviceWorker from './serviceWorker';

//const strLoc = useContext(React.createContext("/queries"));
/*
const store = createStore
<!-- Provider store={store}></Provider -->
*/

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
